import {Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from "@angular/material/dialog";

import {HoldableDirective} from "../../../../directives/holdable.directive";
import {BicButtonComponent} from "@buildinginformationcloud/bic-ui-components";

@Component({
  selector: 'app-pop-up-window',
  templateUrl: './pop-up-window.component.html',
  styleUrls: ['./pop-up-window.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    HoldableDirective,
    MatDialogContent,
    BicButtonComponent
  ]
})
export class PopUpWindowComponent implements OnInit {
  data = inject<{
    header: string;
    message: string;
    approveButtonName: string;
    holdable: boolean;
  }>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<PopUpWindowComponent>>(MatDialogRef);


  holdable: boolean = false;

  ngOnInit(): void {
    this.holdable = this.data.holdable;
  }

  holdHandler(e: any) {
    if (e === 1500) {
     this.approvePressed();
      }
  }

  approvePressed() {
    this.dialogRef.close({approvePressed: true});
  }

  declinePressed() {
    this.dialogRef.close({approvePressed: false});
  }

}
